import React from "react";
import { useState } from "react";
import { Skeleton } from "@purpur/skeleton";

import { cx } from "./classnames";

export type RadioCardImageProps = {
  ["data-testid"]?: string;
  altText: string;
  loading?: "lazy" | "eager";
  noPlaceholder?: boolean;
  src: string;
};

const rootClassName = "purpur-radio-card-group__item-image";

export const isRadioCardItemImageProps = (
  imageProps?: RadioCardImageProps | unknown
): imageProps is RadioCardImageProps =>
  !!(imageProps as RadioCardImageProps)?.src && !!(imageProps as RadioCardImageProps).altText;

export const RadioCardImage = ({
  src,
  altText,
  noPlaceholder,
  loading = "lazy",
  ["data-testid"]: dataTestid,
}: RadioCardImageProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const onLoad = () => setIsLoaded(true);

  const imageClassName = cx(rootClassName, {
    [`${rootClassName}--loaded`]: isLoaded,
  });

  const placeholderClassName = cx(`${rootClassName}-placeholder`, {
    [`${rootClassName}-placeholder--loaded`]: isLoaded,
  });

  return (
    <>
      <img
        data-testid={dataTestid}
        className={imageClassName}
        src={src}
        alt={altText}
        loading={loading}
        onLoad={onLoad}
      />
      {!noPlaceholder && <Skeleton className={placeholderClassName} />}
    </>
  );
};
